module.exports = __webpack_public_path__ + "img/icon_huxi_232.8a313551.png";